(() => {
 const key = '__daljiPromotionRulesLoaded';
 if (window[key]) return;
 window[key] = true;
 const states = { scheduled: 'Em breve', active: 'Vigente', ended: 'Encerrada', invalid: 'Consulte as condições' };
 const clocks = new WeakMap();
 function update(root) {
  let clock = clocks.get(root);
  if (!clock) { clock = { server: Number(root.dataset.serverNow) * 1000, anchor: performance.now() }; clocks.set(root, clock); }
  const now = clock.server + performance.now() - clock.anchor;
  root.querySelectorAll('[data-promotion]').forEach(card => {
   const start = Date.parse(card.dataset.start), end = Date.parse(card.dataset.end);
   const valid = Number.isFinite(now) && Number.isFinite(start) && Number.isFinite(end) && end > start;
   const state = !valid ? 'invalid' : now < start ? 'scheduled' : now >= end ? 'ended' : 'active';
   card.dataset.state = state;
   const label = card.querySelector('[data-promotion-status]');
   if (label && label.textContent !== states[state]) label.textContent = states[state];
   card.querySelectorAll('[data-promotion-action]').forEach(action => { action.hidden = state !== 'active'; });
  });
  root.querySelectorAll('.dalji-promotion-history a[href]').forEach(link => { link.removeAttribute('href'); });
 }
 const refresh = () => document.querySelectorAll('[data-promotion-rules]').forEach(update);
 refresh();
 setInterval(refresh, 1000);
 document.addEventListener('visibilitychange', refresh);
 window.addEventListener('pageshow', refresh);
 document.addEventListener('shopify:section:load', refresh);
})();
